import React, { useContext } from "react";
import fieldPropTypes from "./field-prop-types";
import { RootContext } from "../context/root-ref";
import useElementPrinter from "../utils/element-printer";

const isButton = fieldName => {
  /* You could add here names of filelds which should use the <Button /> component */
  const buttonFields = ["delete_care_team_relation_button"];
  return buttonFields.includes(fieldName);
};
const ButtonView = ({
  field: { name, title, image, params },
  components: { Text, Button },
  onClick
}) => (
  <div className='button-wrapper-web-sdk'>
    {image ? (
      <span
        data-testid='button-view-image'
        className={`icon-web-sdk ${image}`}
      />
    ) : null}
    {isButton(name) ? (
      <Button
        name={name}
        text={title}
        className={`${
          params.includes("TDFieldOptionSecondaryAction") ? "secondary" : ""
        }`}
        params={params}
        label={title}
        onClick={onClick}
      />
    ) : (
      <Text name={name} label={title} onClick={onClick} />
    )}
  </div>
);

const BasicButton = ({ field, appData: { handleButtonClick }, components }) => {
  const handleClick = event => {
    if (field.action) {
      event.stopPropagation();
      handleButtonClick(field.name, field.text, field.action);
    }
  };

  return (
    <ButtonView field={field} components={components} onClick={handleClick} />
  );
};

const PrintButton = ({ field, components }) => {
  const rootRef = useContext(RootContext);
  const printRoot = useElementPrinter(rootRef.current);
  return (
    <ButtonView field={field} components={components} onClick={printRoot} />
  );
};

const Button = ({ field, appData, components }) => {
  const { action } = field;
  const ButtonImpl =
    action && action.type === "selector" && action.value === "printData"
      ? PrintButton
      : BasicButton;
  return <ButtonImpl field={field} appData={appData} components={components} />;
};

PrintButton.propTypes = fieldPropTypes;
BasicButton.propTypes = fieldPropTypes;
ButtonView.propTypes = fieldPropTypes;
Button.propTypes = fieldPropTypes;

export default Button;
